<div class="page-padding">
  <div class="panel">
    <div class="panel__header">
      <span *ngIf="SystemTypeId == 1" class="panel__header__title">
        Undercarriage Rebuild Centre - {{jobNumber}} -
        Chain
      </span>
      <span *ngIf="SystemTypeId == 2" class="panel__header__title">
        Undercarriage Rebuild Centre - {{jobNumber}} -
        Idler
      </span>
      <div class="panel__header__button-container">

        <!--<a *ngIf="SystemTypeId==2" mat-raised-button target="_blank" href="/api/wsre/GetPdfIdler?wsreid={{wsreId}}">
          <i class="material-icons button__icon">save_alt</i>
          PDF
        </a>-->
        <a *ngIf="SystemTypeId==1" mat-raised-button target="_blank" href="/api/wsre/GetWSREChainPdf?wsreid={{wsreId}}">
          <i class="material-icons button__icon">save_alt</i>
          PDF
        </a>
        <!-- <a *ngIf="SystemTypeId==1" mat-raised-button target="_blank" href="/api/wsre/getpdf?wsreid={{wsreId}}">
          <i class="material-icons button__icon">save_alt</i>
          PDF
        </a> -->
        <!-- <a *ngIf="SystemTypeId==2"class="button button--primary" target="_blank" href="/api/wsre/GetPdfIdler?wsreid={{wsreId}}"><i
            class="material-icons button__icon"  >save_alt</i><span class="button__text">PDF</span></a>

        <a *ngIf="SystemTypeId==1"class="button button--primary" target="_blank" href="/api/wsre/getpdf?wsreid={{wsreId}}"><i
                class="material-icons button__icon">file_download</i><span class="button__text">Download
                PDF</span></a> -->

        <button mat-raised-button color="warn" (click)="sendReport()">Send Report</button>
        <!-- <a (click)="sendReport()"><i style="vertical-align: middle;"
        class="material-icons button__icon">send</i><span class="button__text">Send Report</span></a> -->



      </div>
    </div>
    <div class="panel__content flex flex--align-center">
      <a *ngIf="SystemTypeId==1">
        <img class="image--chain" src="/Content/Images/chain.jpg" alt="Chain">
      </a>
      <a *ngIf="SystemTypeId==2">
        <img class="image--chain" src="/Content/Images/Idler Image WSRE.jpg" alt="Idler">
      </a>
      <div class="column-container flex-grow">
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Customer
            </span>
            <span class="text-block__important">
              {{customerName}}
            </span>
          </div>
          <!-- <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <span class="text-block__important">
              {{jobsiteName}}
            </span>
          </div> -->
          <div class="text-block">
            <span class="text-block__label">
              Job Site
            </span>
            <div class="component-container">
              <div matTooltip="Change Job Site" [matMenuTriggerFor]="changeJobSite" class="text-container"
                title="Click to edit" *ngIf="allowJobsiteEditing">
                <span class="text-container__text">
                  {{jobsiteName}}
                </span>
                <i class="material-icons text-container__edit" style="cursor: pointer" (click)="toggleJobSiteEdit(true)">
                  edit
                </i>
              </div>
              <div class="text-container" *ngIf="!allowJobsiteEditing">
                <span class="text-container__text">
                  {{jobsiteName}}
                </span>
              </div>
              <mat-menu #changeJobSite="matMenu" style="cursor: pointer">
                <button mat-menu-item *ngFor="let site of jobSiteList" (click)="saveJobSite(site)">
                  {{site.Name}}
                </button>
              </mat-menu>
            </div>
          </div>
        </div>
        <div class="column-container__column">
          <!-- <div class="text-block">
            <span class="text-block__label">
              Serial Number
            </span>
            <span class="text-block__important">
              {{serialNumber}}
            </span>
          </div> -->

          <div class="text-block">
  <span class="text-block__label">
    Serial Number

    <span *ngIf="isSerialNumberEditable" class="text-block__important">
      <input 
        class="input-container__input" 
        [(ngModel)]="serialNumber"
      />
      <i 
        class="material-icons save-button__icon editcancel" 
        style="cursor: pointer;" 
        (click)="saveSerialNumber()">
        check
      </i>
      <i 
        class="material-icons cancel-button__icon editcancel" 
        style="cursor: pointer;" 
        (click)="toggleSerialNumberEdit(false)">
        close
      </i>
    </span>
  </span>

  <span *ngIf="!isSerialNumberEditable" class="text-block__important">
    {{serialNumber}}
    <i 
      class="material-icons text-container__edit" 
      style="cursor: pointer;" 
      (click)="toggleSerialNumberEdit(true)" 
      >
      edit
    </i>
  </span>
</div>
          <div class="text-block">
            <span class="text-block__label">
              Inspection Date
            </span>
            <span class="text-block__important">
              {{inspectionDate | amDateFormat:'LL'}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Make
            </span>
            <span class="text-block__important">
              {{make}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Model
            </span>
            <span class="text-block__important">
              {{model}}
            </span>
          </div>
        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Life Lived (hrs)
            </span>
            <span class="text-block__important">
              {{lifeLived}}
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">

            </span>
            <span class="text-block__important">

            </span>
          </div>
        </div>
        
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Job Number
        
            <span *ngIf="isJobNumberEditable" class="text-block__important">
              <input 
                class="input-container__input" 
                [(ngModel)]="jobNumber"
              
              />
              <i 
                class="material-icons save-button__icon editcancel" 
                style="cursor: pointer;" 
                (click)="saveJobNumber()">
                check
              </i>
              <i 
                class="material-icons cancel-button__icon editcancel" 
                style="cursor: pointer;" 
                (click)="toggleJobNumberEdit(false)" >
                close
              </i>
            </span>
            </span>
            <span *ngIf="!isJobNumberEditable" class="text-block__important">
              {{jobNumber}}
              <i 
              class="material-icons text-container__edit" 
              style="cursor: pointer;" 
              (click)="toggleJobNumberEdit(true)">
              edit
               
            </i>
            </span>
          </div>
          <div class="text-block">
            <span class="text-block__label">
              Customer Reference
             
            </span>
            <span *ngIf="isCustomerReferenceEditable" class="text-block__important">
              <input 
                class="input-container__input" 
                [(ngModel)]="customerReference"
              
              />
              <i 
                class="material-icons save-button__icon editcancel" 
                style="cursor: pointer;" 
                (click)="saveCustomerReference()">
                check
              </i>
              <i 
                class="material-icons cancel-button__icon editcancel" 
                style="cursor: pointer;" 
                (click)="toggleCustomerReferenceEdit(false)">
                close
              </i>
            </span>
            <span *ngIf="!isCustomerReferenceEditable" class="text-block__important">
              {{customerReference}}  <i 
              class="material-icons text-container__edit" 
              style="cursor: pointer;" 
              (click)="toggleCustomerReferenceEdit(true)"  >
              edit
            </i>
            </span>
          </div>
          

        </div>
        <div class="column-container__column">
          <div class="text-block">
            <span class="text-block__label">
              Old Job Number
             
            </span>
            <span *ngIf="isOldJobNumberEditable" class="text-block__important">
              <input 
                class="input-container__input" 
                [(ngModel)]="oldJobNumber" 
               
              />
              <i 
                class="material-icons save-button__icon editcancel" 
                style="cursor: pointer;" 
                (click)="saveOldJobNumber()">
                check
              </i>
              <i 
                class="material-icons cancel-button__icon editcancel" 
                style="cursor: pointer;" 
                (click)="toggleOldJobNumberEdit(false)">
                close
              </i>
            </span>
            <span *ngIf="!isOldJobNumberEditable" class="text-block__important">
              {{oldJobNumber}}  <i 
              class="material-icons text-container__edit" 
              style="cursor: pointer;" 
              (click)="toggleOldJobNumberEdit(true)"  >
              edit
            </i>
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="panel">
    <mat-tab-group (selectedTabChange)="viewTab($event)">
      <mat-tab label="Summary">

        <div class="col-lg-3"></div>
        <div class="col-lg-9">
          <mat-label>Status: </mat-label>
          <mat-form-field>
            <mat-select id="wsreId"
                        [(ngModel)]="WSREStatusID" (selectionChange)="OnStatusChange()" ngDefaultControl>
              <mat-option [value]="dep.StatusId" *ngFor="let dep of WSREStatus">
                {{dep.StatusName}}
              </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
        <div class="panel__content flex flex--top">
          <div class="center" *ngIf="loadingSummary">
            <mat-spinner></mat-spinner>
          </div>
          <ng-container *ngIf="!loadingSummary">
            <div class="eval Eval-{{overallEval}}" [class.saving-crack-test-eval]="savingOverallEval">
              {{overallEval}}
              <div class="change-eval" [matMenuTriggerFor]="overallEvalMenu" *ngIf="userCanEdit">
                <i class="material-icons change-eval__icon">mode_edit</i>
                <span class="change-eval__text">Change</span>
              </div>
              <mat-menu #overallEvalMenu="matMenu">
                <button mat-menu-item (click)="saveOverallEval('A')">A</button>
                <button mat-menu-item (click)="saveOverallEval('B')">B</button>
                <button mat-menu-item (click)="saveOverallEval('C')">C</button>
                <button mat-menu-item (click)="saveOverallEval('X')">X</button>
              </mat-menu>
            </div>
            <div>
              <div class="text-block">
                <span class="text-block__label">Overall Summary Comment</span>
                <span class="text-block__important">
                  <edit-data [canEdit]="userCanEdit" [value]="overallSummaryComment"
                             [dataType]="'textarea'" (valueChanged)="saveOverallSummaryComment($event)">
                  </edit-data>
                </span>
              </div>
              <div class="text-block">
                <span class="text-block__label">Overall Summary Recommendation</span>
                <span class="text-block__important">
                  <edit-data [canEdit]="userCanEdit" [value]="overallSummaryRecommendation"
                             [dataType]="'textarea'"
                             (valueChanged)="saveOverallSummaryRecommendation($event)"></edit-data>
                </span>
              </div>
              <div class="text-block">
                <span class="text-block__label">Components</span>
                <span *ngIf="componentSummaries == null || componentSummaries.length == 0">
                  No component
                  summary data found.
                </span>
                <div class="flex" *ngIf="componentSummaries != null">
                  <div class="text-block__important component-summary"
                       *ngFor="let component of componentSummaries">
                    <div>
                      <div class="component-summary__eval component-summary__eval--{{component.WornPercentage | wornPercentageToEval}}">
                        <span>{{component.Type}}</span>
                        <span class="eval-inline"> - {{component.WornPercentage}}%</span>
                      </div>
                      <span *ngIf="component.Recommendations.length > 0">
                        <span class="recommendation" matTooltip="Recommended Action"
                              *ngFor="let recommendation of component.Recommendations">{{recommendation}}</span>
                      </span>
                      <div *ngIf="component.Comment != ''" class="component-comment">
                        {{component.Comment}}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div *ngIf="SystemTypeId ==1" class="text-block">
                <span class="text-block__label">Crack Tests</span>
                <span *ngIf="crackTestSummary == null">No crack test data found. </span>
                <div class="text-block__important component-summary" *ngIf="crackTestSummary != null">
                  <div class="component-summary__eval"
                       [class.red-bg]="crackTestSummary.Passed == false"
                       [class.gray-bg]="crackTestSummary.Passed == null">
                    <span>
                      {{
crackTestSummary.Passed == null ? "N/A" :crackTestSummary.Passed ?
                                            'Passed' : 'Failed'
                      }}
                    </span>
                  </div>
                  {{crackTestSummary.Comment}}
                </div>
              </div>
              <div *ngIf="SystemTypeId ==1" class="text-block">
                <span class="text-block__label">Dip Tests</span>
                <span *ngIf="dipTestSummaries == null || dipTestSummaries.length == 0">
                  There are no dip
                  tests which require your attention.
                </span>
                <div class="flex" *ngIf="dipTestSummaries != null">
                  <div class="text-block__important component-summary"
                       *ngFor="let dipTest of dipTestSummaries">
                    <div class="component-summary__eval" [style.background-color]="dipTest.Colour">
                      Pin {{dipTest.Number}} - <span>{{dipTest.Problem}}</span>
                    </div>
                    {{dipTest.Comment}}
                  </div>
                </div>
              </div>
            </div>
          </ng-container>
        </div>
      </mat-tab>
      <mat-tab label="Photos">
        <div class="panel__content">
          <div class="text-block">
            <span class="text-block__label">Arrival Photos</span>
            <div class="flex" style="flex-direction: column;">

        <td class="table__eval-cell">
          <upload-photo-wsre (onPhotoUpload)="uploadArrivalPhotos($event)" [uploadEndPoint]="3"
                             [relatedId]="wsreId"></upload-photo-wsre>

          <img *ngFor="let photo of arrivalPhotos" (click)="openImage(photo.Id, 'initial')"
               [src]="getImage(photo.ImageData)" class="component-photo"
               matTooltip="{{photo.Title}}" />
        </td>

  </div>
</div>

<div class="text-block">
  <span class="text-block__label">Final Photo</span>
  <div class="flex" style="flex-direction: column;">

    <td class="table__eval-cell">
      <upload-photo-wsre (onPhotoUpload)="uploadArrivalPhotos($event)" [uploadEndPoint]="17"
                         [relatedId]="wsreId"></upload-photo-wsre>

      <img *ngFor="let photo of finalPhotos" (click)="openImage(photo.Id, 'initial')"
           [src]="getImage(photo.ImageData)" class="component-photo"
           matTooltip="{{photo.Title}}" />
    </td>

  </div>
</div>

<div class="text-block">
  <span class="text-block__label">Customer Reference Photos</span>
  <div class="flex" style="flex-direction: column;">

    <td class="table__eval-cell">
      <upload-photo-wsre (onPhotoUpload)="customerReferencePhotoUploaded($event)"
                         [uploadEndPoint]="4" [relatedId]="wsreId"></upload-photo-wsre>

      <img *ngFor="let photo of customerReferencePhotos"
           (click)="openImage(photo.Id, 'initial')" [src]="getImage(photo.ImageData)"
           class="component-photo" matTooltip="{{photo.Title}}" />
    </td>


  </div>
</div>
<div class="text-block">
  <span class="text-block__label">Old Tag Photos</span>
  <div class="flex" style="flex-direction: column;">

    <td class="table__eval-cell">
      <upload-photo-wsre (onPhotoUpload)="oldTagPhotoUploaded($event)" [uploadEndPoint]="5"
                         [relatedId]="wsreId"></upload-photo-wsre>

      <img *ngFor="let photo of oldTagPhotos" (click)="openImage(photo.Id, 'initial')"
           [src]="getImage(photo.ImageData)" class="component-photo"
           matTooltip="{{photo.Title}}" />
    </td>


  </div>
</div>



                </div>
            </mat-tab>
<mat-tab label="Components" *ngIf="componentsLoaded && components.length > 0">
  <div class="panel__content no-padding" *ngIf="viewComponents">
    <div class="columnsheadersmgr" *ngIf="isBasicUser==1">
      <mat-checkbox [(ngModel)]="editComponent" *ngIf="isAdministrator" class="margin">
        <span class="example-margin">
          {{"Edit Component" | translate | async}}
        </span>
      </mat-checkbox>
    </div>
    <table class="table table--full-width table--striped">
      <thead>
        <tr>
          <th>Worn (%)</th>
          <th>Component</th>
          <th>Brand</th>
          <th></th>
          <th></th>
          <th>Measurement ({{userUom}})</th>
          <th>Tool</th>
          <th>Crack Tests</th>
          <th>Record Actions</th>
          <th>Recommendations</th>
          <th>Comment</th>
          <th>Photos Taken</th>
        </tr>
      </thead>
      <tbody *ngFor="let component of components">
        <tr>

          <td>
            <mat-label *ngIf="component.CompartTypeAuto == 230"
                       style="font-weight: bold;margin-bottom: 5px;"><u>Link</u></mat-label>
            <mat-label *ngIf="component.CompartTypeAuto == 231"
                       style="font-weight: bold;margin-bottom: 5px;"><u>Bushes</u></mat-label>
            <mat-label *ngIf="component.CompartTypeAuto == 232"
                       style="font-weight: bold;margin-bottom: 5px;"><u>Shoe</u></mat-label>
            <mat-label *ngIf="component.CompartTypeAuto == 233"
                       style="font-weight: bold;margin-bottom: 5px;"><u>Idler</u></mat-label>

            <div class="table__eval-cell">
              <div class="Eval-{{component.WornPercentage | wornPercentageToEval}}">
                {{component.WornPercentage}}%
              </div>
            </div>

          </td>
          <td>{{ component.Component }}
            <span *ngIf="editComponent">
              <i
                class="material-icons text-container__edit"
                style="cursor: pointer; font-size: 16px;"
                title="Click to edit Component"
                (click)="openEditComponentPopup(component)">
                edit
              </i>
            </span>
          </td>
          <td>{{component.Brand}}</td>
          <td></td>
          <td></td>
          <td>
            <input #txt type="text" name="field"
                   (focus)="txt.setAttribute('data-value', component.Measurement)"
                   (blur)="txt.getAttribute('data-value') !== component.Measurement ? saveComponentMeasurement(component.Measurement, component.Id,component.ToolId,component) : ''"
                   [(ngModel)]="component.Measurement" />
                    <div *ngIf="component.ToolId === toolType.Eval">
                    <span [matMenuTriggerFor]="evalMenu" class="tool-button"
                      title="{{'Change Eval' | translate | async}}">{{c.Conditon }}</span>
                  </div>
              <div *ngIf='component.ToolId === toolType.YESorNO'>
                  <span [matMenuTriggerFor]="yesNoMenu" class="tool-button" title="{{ 'Change Component Yes/No' | translate | async }}">
                   {{component.MeasurementPoints === 1 ? ('Yes' | translate | async) : 
                    component.MeasurementPoints === 0 ? ('No' | translate | async) : ''}}
                  </span>                  
                  <mat-menu #yesNoMenu="matMenu">
                    <button mat-menu-item (click)="saveComponentMeasurement(toolYesNo.Yes, component.Id,component.ToolId,component)">{{ 'Yes' | translate | async }}</button>
                    <button mat-menu-item (click)="saveComponentMeasurement(toolYesNo.No, component.Id,component.ToolId,component)">{{ 'No' | translate | async }}</button>
                  </mat-menu>
                </div>
                 <div *ngIf='component.ToolId === toolType.PassorFail'>
                  <span [matMenuTriggerFor]="passFailMenu" class="tool-button" title="{{ 'Change Component Pass/Fail' | translate | async }}">
                     {{ component.MeasurementPoints === 1 ? ('Pass' | translate | async) :
                     component.MeasurementPoints === 0 ? ('Fail' | translate | async) :''
                  }}
                  </span>
                  <mat-menu #passFailMenu="matMenu">
                    <button mat-menu-item (click)="saveComponentMeasurement(toolPassFail.Pass, component.Id,component.ToolId,component)">{{ 'Pass' | translate | async }}</button>
                    <button mat-menu-item (click)="saveComponentMeasurement(toolPassFail.Fail, component.Id,component.ToolId,component)">{{ 'Fail' | translate | async }}</button>
                  </mat-menu>
                </div>     
            <!-- <edit-data [canEdit]="userCanEdit" [value]="component.Measurement"
                class="child-input"
                (valueChanged)="saveComponentMeasurement($event, component.Id,component.ToolId)">
            </edit-data> -->
          </td>
          <td>
            <div>
              <span [matMenuTriggerFor]="selectToolMenu" class="tool-button"
                    title="{{'Change tool'}}">{{component.Tool}}</span>
              <mat-menu #selectToolMenu="matMenu">
                <button mat-menu-item *ngFor="let tool of component.PossibleTools"
                        (click)="updateComponentTool(component.Measurement, component.Id,tool.ToolId,component)">
                  {{
                    tool.ToolName
                  }}
                </button>

              </mat-menu>
            </div>

          </td>
          <th>
            <div style="min-width: 100px;"></div>
          </th>
          <td>

            <div style="display: flex;">
              <div>
                <button mat-icon-button (click)="loadActions(component.CompartTypeAuto,component.ComponentId,component.SystemId)" aria-label="Example icon-button with a menu">
                  <mat-icon>edit</mat-icon>
                </button>
              </div>
              <div style="padding-top: 10px;">

                <div *ngIf="component.ActionHistoryCount > 0; else NoHistory" style="padding-top: 10px;">
                  <i [matTooltip]="'Total Action(s) Recorded: ' + component.ActionHistoryCount" class="material-icons"
                     style="color: green;cursor: pointer;padding-top: 3px"
                     (click)="openHistory(component)">
                    chat_bubble_outline
                  </i>
                </div>

                <ng-template #NoHistory>
                  <i title="No History" class="material-icons"
                     style="color: rgb(230, 220, 220);padding-top: 3px;">
                    chat_bubble_outline
                  </i>
                </ng-template>
              </div>


               <div class="popup" #popupRef *ngIf="isPopupVisible && (component.ComponentId == currentClickedId)">
                    <ng-container>
                      <mat-checkbox *ngFor="let option of availableActions" [checked]="selectedOption === option"
                        (change)="onCheckboxChange(option,component.ComponentTypeId,component.ComponentId)">
                        {{ option.ActionTypeName }}
                      </mat-checkbox>

                      <div *ngIf="isReplaceWithNewAction" [@fadeInOut]>
                        <div>
                          <mat-form-field class="input">
                            <mat-select (selectionChange)="replacementCompartChanged($event,component.ComponentId)"
                              [(ngModel)]="action.ReplaceComponentCompartId" placeholder="{{Translate('Compartment')}}">
                              <mat-option *ngFor="let compart of availableCompartments" [value]="compart.Id"  [matTooltip]="compart.Name">
                                {{ compart.Name }}
                              </mat-option>
                            </mat-select>
                          </mat-form-field>
                        </div>
                      </div>

                      <div
                        *ngIf="+selectedActionTypeID === 10602 || +selectedActionTypeID=== 17 || +selectedActionTypeID === 10702">
                        <mat-form-field class="action-input" *ngIf="allRollers?.length >= 1">
                          <mat-select name="Roller To Swap"
                            placeholder="{{'Select Swap component' | translate | async}}">
                            <mat-option *ngFor="let roller of allRollers" (click)="swapRollerEvent(roller)"
                              [value]="roller">
                              {{ roller.Name }} {{ roller.Position }}
                            </mat-option>
                          </mat-select>
                        </mat-form-field>
                      </div>
                    </ng-container>
                    <div style="display: flex;">
                      <button mat-raised-button (click)="popupClose()">Close</button>
                      <button mat-raised-button color="warn" (click)="RecordAction()">Save</button>
                    </div>
                  </div>
              <!-- <div class="popup" *ngIf="isPopupVisible && (component.ComponentId == currentClickedId)">
                <ng-container>
                  <mat-checkbox *ngFor="let option of availableActions"
                                [checked]="selectedOption === option"
                                (change)="onCheckboxChange(option, ,component.ComponentId)">
                    {{ option.ActionTypeName }}
                  </mat-checkbox>
                </ng-container>
                <div style="display: flex;">
                  <button mat-raised-button (click)="popupClose()">Close</button>
                  <button mat-raised-button color="warn" (click)="RecordAction()">Save</button>
                </div>
              </div> -->
            </div>






          </td>
          <td>
            <span class="recommendation" matTooltip="Recommended Action"
                  *ngFor="let recommendation of component.Recommendations">{{recommendation}}</span>
          </td>
          <td style="width: 280px;align-items: center;justify-content: center;">
            <!-- <edit-data [canEdit]="userCanEdit" [value]="component.Comment" style="height: 50px;"
                (valueChanged)="saveComponentComment($event, component.Id)"></edit-data> -->


            <i [matTooltip]="component.Comment == '' ? 'Add Comment' : component.Comment"
               class="material-icons condition__icon"
               style="cursor: pointer;"
               [class.has-comment]="component.Comment && component.Comment.length > 0"
               (click)="openConditionComment(component.Comment,component.Id)">
              chat_bubble{{component.Comment&&component.Comment.length > 0 ?'':'_outline'}}
            </i>
          </td>
          <td class="table__eval-cell">
            <upload-photo-wsre (onPhotoUpload)="componentPhotoUploaded($event)"
                               [uploadEndPoint]="0" [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngFor="let photo of component.Photos" matTooltip="{{photo.Title}}"
               class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(photo.Id, 'component')">
              add_a_photo
            </i>

          </td>


        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <span>Dia A </span>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">New </mat-label>

              <mat-label style="margin-right: 10px;width: 70px;">
                {{component.Idlr_Dia_A_New==null?'N/A':component.Idlr_Dia_A_New }}
              </mat-label>


            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">100% </mat-label>
              <mat-label style="margin-right: 10px;width: 70px;">
                {{component.Idlr_Dia_A_100prc ==null? 'N/A':component.Idlr_Dia_A_100prc }}
              </mat-label>

            </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;"> </mat-label>

              <input class="child-input" #Idlr_Dia_A_measurment type="text"
                     (focus)="Idlr_Dia_A_measurment.setAttribute('data-value', component.Idlr_Dia_A_measurment)"
                     (blur)="Idlr_Dia_A_measurment.getAttribute('data-value') !== component.Idlr_Dia_A_measurment ? saveChildComponentMeasurement(component.Idlr_Dia_A_measurment, component.Id,component.ToolId,52) : ''"
                     [(ngModel)]="component.Idlr_Dia_A_measurment" />

              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_Dia_A_measurment"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,52)">
              </edit-data> -->
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <span>Dia B </span>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">New </mat-label>
              <mat-label style="margin-right: 10px;width: 70px;">
                {{component.Idlr_Dia_B_New ==null?'N/A':component.Idlr_Dia_B_New}}
              </mat-label>


            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">100% </mat-label>
              <mat-label style="margin-right: 10px;width: 70px;">
                {{component.Idlr_Dia_B_100prc==null?'N/A':component.Idlr_Dia_B_100prc}}
              </mat-label>

            </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;"> </mat-label>

              <input class="child-input" #Idlr_Dia_B_measurment type="text"
                     (focus)="Idlr_Dia_B_measurment.setAttribute('data-value', component.Idlr_Dia_B_measurment)"
                     (blur)="Idlr_Dia_B_measurment.getAttribute('data-value') !== component.Idlr_Dia_B_measurment ? saveChildComponentMeasurement(component.Idlr_Dia_B_measurment, component.Id,component.ToolId,53) : ''"
                     [(ngModel)]="component.Idlr_Dia_B_measurment" />

              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_Dia_B_measurment"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,53)">
              </edit-data> -->
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <span>Width of center guide </span>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">New </mat-label>
              <mat-label style="margin-right: 10px;width: 70px;">
                {{component.Idlr_WidthOfCG_New ==null? 'N/A':component.Idlr_WidthOfCG_New }}
              </mat-label>

              <!-- <edit-data [canEdit]="false" class="child-input"
                  [value]="component.Idlr_WidthOfCG_New"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,28)">
              </edit-data> -->
            </div>
          </td>
          <td></td>
          <td></td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;"> </mat-label>



              <input class="child-input" #WidthOfCenterGuide_measurment type="text"
                     (focus)="WidthOfCenterGuide_measurment.setAttribute('data-value', component.WidthOfCenterGuide_measurment)"
                     (blur)="WidthOfCenterGuide_measurment.getAttribute('data-value') !== component.WidthOfCenterGuide_measurment ? saveChildComponentMeasurement(component.WidthOfCenterGuide_measurment, component.Id,component.ToolId,54) : ''"
                     [(ngModel)]="component.WidthOfCenterGuide_measurment" />

            </div>
          </td>

          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.WidthOfCenterGuide_photo == null"
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="7"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.WidthOfCenterGuide_photo != null && component.WidthOfCenterGuide_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.WidthOfCenterGuide_photo.Id, 'WidthOfCenterGuide_photo', 1)">
              add_a_photo
            </i>

          </td>

        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <span>Shaft Ok to reuse </span>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <span style="margin-right: 10px;height: 10px;width: 70px;"> </span>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_ShaftOTR==1, 'Fail' : component.Idlr_ShaftOTR==2}">
                {{
component.Idlr_ShaftOTR==1 ? 'YES' : component.Idlr_ShaftOTR==2
                                            ?'NO':'N/A'
                }}
                <div class="change-eval" [matMenuTriggerFor]="Idlr_ShaftOTRCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_ShaftOTRCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,29)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,29)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,29)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.ShaftOkToReuse_photo == null"
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="8"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.ShaftOkToReuse_photo != null && component.ShaftOkToReuse_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.ShaftOkToReuse_photo.Id, 'ShaftOkToReuse_photo', 2)">
              add_a_photo
            </i>

          </td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <span>Measure into 150mm from the face.</span>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Std size is </mat-label>
              <edit-data [canEdit]="false" class="child-input"
                         [value]="component.Idlr_Measure_in_to_150_1==null?'N/A':component.Idlr_Measure_in_to_150_1 "
                         (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,30)">
              </edit-data>



            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">+/- </mat-label>



              <edit-data [canEdit]="false" class="child-input"
                         [value]="component.Idlr_Measure_in_to_tolerancr ==null?'N/A':component.Idlr_Measure_in_to_tolerancr "
                         (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,31)">
              </edit-data>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td></td>

          <td style="text-align: center;">
            <mat-label style="font-weight: bold;">Before Rebuild </mat-label>
          </td>
          <td style="text-align: center;">
            <mat-label style="font-weight: bold;">Before Rebuild </mat-label>
          </td>
          <td style="text-align: center;">
            <mat-label style="font-weight: bold;">Before Rebuild </mat-label>

          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;">No.1 Side </mat-label>
              <mat-label>N/S</mat-label>

            </div>


          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>

              <input class="child-input" #Idlr_No_1_side_NS_Face type="text"
                     (focus)="Idlr_No_1_side_NS_Face.setAttribute('data-value', component.Idlr_No_1_side_NS_Face)"
                     (blur)="Idlr_No_1_side_NS_Face.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Face ? saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Face, component.Id,component.ToolId,32) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Face" />

              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,32)">
              </edit-data> -->
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>

              <input class="child-input" #Idlr_No_1_side_NS_Middle type="text"
                     (focus)="Idlr_No_1_side_NS_Middle.setAttribute('data-value', component.Idlr_No_1_side_NS_Middle)"
                     (blur)="Idlr_No_1_side_NS_Middle.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Middle ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Middle, component.Id,component.ToolId,33) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Middle" />

              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,33)">
              </edit-data> -->
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,34)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_NS_Centre type="text"
                     (focus)="Idlr_No_1_side_NS_Centre.setAttribute('data-value', component.Idlr_No_1_side_NS_Centre)"
                     (blur)="Idlr_No_1_side_NS_Centre.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Centre ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Centre, component.Id,component.ToolId,34) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Centre" />

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.No1SideNS_photo == null "
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="10"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.No1SideNS_photo != null && component.No1SideNS_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.No1SideNS_photo.Id, 'No1SideNS_photo', 4)">
              add_a_photo
            </i>

          </td>

        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="height: 10px;width: 70px;"> </mat-label>
              <mat-label>E/W</mat-label>

            </div>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,35)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_ES_Face type="text"
                     (focus)="Idlr_No_1_side_ES_Face.setAttribute('data-value', component.Idlr_No_1_side_ES_Face)"
                     (blur)="Idlr_No_1_side_ES_Face.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Face ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Face, component.Id,component.ToolId,35) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Face" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,36)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_ES_Middle type="text"
                     (focus)="Idlr_No_1_side_ES_Middle.setAttribute('data-value', component.Idlr_No_1_side_ES_Middle)"
                     (blur)="Idlr_No_1_side_ES_Middle.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Middle ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Middle, component.Id,component.ToolId,36) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Middle" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,37)">
              </edit-data> -->


              <input class="child-input" #Idlr_No_1_side_ES_Centre type="text"
                     (focus)="Idlr_No_1_side_ES_Centre.setAttribute('data-value', component.Idlr_No_1_side_ES_Centre)"
                     (blur)="Idlr_No_1_side_ES_Centre.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Centre ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Centre, component.Id,component.ToolId,37) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Centre" />
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.No1SideES_photo == null "
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="11"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.No1SideES_photo != null && component.No1SideES_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.No1SideES_photo.Id, 'No1SideES_photo', 5)">
              add_a_photo
            </i>

          </td>

        </tr>




        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;">No.2 Side </mat-label>
              <mat-label>N/S</mat-label>

            </div>


          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,38)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_NS_Face type="text"
                     (focus)="Idlr_No_2_side_NS_Face.setAttribute('data-value', component.Idlr_No_2_side_NS_Face)"
                     (blur)="Idlr_No_2_side_NS_Face.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Face ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Face, component.Id,component.ToolId,38) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Face" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,39)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_NS_Middle type="text"
                     (focus)="Idlr_No_2_side_NS_Middle.setAttribute('data-value', component.Idlr_No_2_side_NS_Middle)"
                     (blur)="Idlr_No_2_side_NS_Middle.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Middle ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Middle, component.Id,component.ToolId,39) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Middle" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,40)">
              </edit-data> -->


              <input class="child-input" #Idlr_No_2_side_NS_Centre type="text"
                     (focus)="Idlr_No_2_side_NS_Centre.setAttribute('data-value', component.Idlr_No_2_side_NS_Centre)"
                     (blur)="Idlr_No_2_side_NS_Centre.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Centre ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Centre, component.Id,component.ToolId,40) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Centre" />

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.No2SideNS_photo == null "
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="12"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.No2SideNS_photo != null && component.No2SideNS_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.No2SideNS_photo.Id, 'No2SideNS_photo', 6)">
              add_a_photo
            </i>

          </td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;height: 10px;"> </mat-label>
              <mat-label>E/W</mat-label>

            </div>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,41)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Face type="text"
                     (focus)="Idlr_No_2_side_ES_Face.setAttribute('data-value', component.Idlr_No_2_side_ES_Face)"
                     (blur)="Idlr_No_2_side_ES_Face.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Face ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Face, component.Id,component.ToolId,41) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Face" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,42)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Middle type="text"
                     (focus)="Idlr_No_2_side_ES_Middle.setAttribute('data-value', component.Idlr_No_2_side_ES_Middle)"
                     (blur)="Idlr_No_2_side_ES_Middle.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Middle ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Middle, component.Id,component.ToolId,42) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Middle" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,43)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Centre type="text"
                     (focus)="Idlr_No_2_side_ES_Centre.setAttribute('data-value', component.Idlr_No_2_side_ES_Centre)"
                     (blur)="Idlr_No_2_side_ES_Centre.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Centre ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Centre, component.Id,component.ToolId,43) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Centre" />

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.No2SideES_photo == null "
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="13"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.No2SideES_photo != null && component.No2SideES_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.No2SideES_photo.Id, 'No2SideES_photo', 7)">
              add_a_photo
            </i>

          </td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td></td>

          <td style="text-align: center;">
            <mat-label style="font-weight: bold;">After Rebuild </mat-label>
          </td>
          <td style="text-align: center;">
            <mat-label style="font-weight: bold;">After Rebuild </mat-label>
          </td>
          <td style="text-align: center;">
            <mat-label style="font-weight: bold;">After Rebuild </mat-label>

          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;">No.1 Side </mat-label>
              <mat-label>N/S</mat-label>

            </div>


          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Face_after "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,63)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_NS_Face_after type="text"
                     (focus)="Idlr_No_1_side_NS_Face_after.setAttribute('data-value', component.Idlr_No_1_side_NS_Face_after)"
                     (blur)="Idlr_No_1_side_NS_Face_after.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Face_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Face_after, component.Id,component.ToolId,63) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Face_after" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Middle_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,64)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_NS_Middle_after type="text"
                     (focus)="Idlr_No_1_side_NS_Middle_after.setAttribute('data-value', component.Idlr_No_1_side_NS_Middle_after)"
                     (blur)="Idlr_No_1_side_NS_Middle_after.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Middle_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Middle_after, component.Id,component.ToolId,64) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Middle_after" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Centre_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,65)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_NS_Centre_after type="text"
                     (focus)="Idlr_No_1_side_NS_Centre_after.setAttribute('data-value', component.Idlr_No_1_side_NS_Centre_after)"
                     (blur)="Idlr_No_1_side_NS_Centre_after.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Centre_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Centre_after, component.Id,component.ToolId,65) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Centre_after" />

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <!-- <upload-photo-wsre *ngIf="component.No1SideNS_photo == null "
                (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="10"
                [relatedId]="component.Id"></upload-photo-wsre>

            <i *ngIf="component.No1SideNS_photo_after != null && component.No1SideNS_photo_after.Id != null"
                matTooltip="" class="material-icons upload-container__icon"
                style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                (click)="openImage(component.No1SideNS_photo.Id, 'No1SideNS_photo', 4)">
                add_a_photo
            </i> -->

          </td>

        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="height: 10px;width: 70px;"> </mat-label>
              <mat-label>E/W</mat-label>

            </div>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Face_after "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,66)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_ES_Face_after type="text"
                     (focus)="Idlr_No_1_side_ES_Face_after.setAttribute('data-value', component.Idlr_No_1_side_ES_Face_after)"
                     (blur)="Idlr_No_1_side_ES_Face_after.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Face_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Face_after, component.Id,component.ToolId,66) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Face_after" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Middle_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,67)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_ES_Middle_after type="text"
                     (focus)="Idlr_No_1_side_ES_Middle_after.setAttribute('data-value', component.Idlr_No_1_side_ES_Middle_after)"
                     (blur)="Idlr_No_1_side_ES_Middle_after.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Middle_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Middle_after, component.Id,component.ToolId,67) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Middle_after" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Centre_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,68)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_ES_Centre_after type="text"
                     (focus)="Idlr_No_1_side_ES_Centre_after.setAttribute('data-value', component.Idlr_No_1_side_ES_Centre_after)"
                     (blur)="Idlr_No_1_side_ES_Centre_after.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Centre_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Centre_after, component.Id,component.ToolId,68) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Centre_after" />
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td class="table__eval-cell">
              <upload-photo-wsre *ngIf="component.No1SideES_photo == null "
                  (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="11"
                  [relatedId]="component.Id"></upload-photo-wsre>
              <i *ngIf="component.No1SideES_photo != null && component.No1SideES_photo.Id != null"
                  matTooltip="" class="material-icons upload-container__icon"
                  style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                  (click)="openImage(component.No1SideES_photo.Id, 'No1SideES_photo', 5)">
                  add_a_photo
              </i>

          </td> -->

        </tr>




        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;">No.2 Side </mat-label>
              <mat-label>N/S</mat-label>

            </div>


          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Face_after "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,69)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_NS_Face_after type="text"
                     (focus)="Idlr_No_2_side_NS_Face_after.setAttribute('data-value', component.Idlr_No_2_side_NS_Face_after)"
                     (blur)="Idlr_No_2_side_NS_Face_after.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Face_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Face_after, component.Id,component.ToolId,69) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Face_after" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Middle_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,70)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_NS_Middle_after type="text"
                     (focus)="Idlr_No_2_side_NS_Middle_after.setAttribute('data-value', component.Idlr_No_2_side_NS_Middle_after)"
                     (blur)="Idlr_No_2_side_NS_Middle_after.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Middle_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Middle_after, component.Id,component.ToolId,70) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Middle_after" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Centre_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,71)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_NS_Centre_after type="text"
                     (focus)="Idlr_No_2_side_NS_Centre_after.setAttribute('data-value', component.Idlr_No_2_side_NS_Centre_after)"
                     (blur)="Idlr_No_2_side_NS_Centre_after.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Centre_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Centre_after, component.Id,component.ToolId,71) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Centre_after" />
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td class="table__eval-cell">
              <upload-photo-wsre *ngIf="component.No2SideNS_photo == null "
                  (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="12"
                  [relatedId]="component.Id"></upload-photo-wsre>
              <i *ngIf="component.No2SideNS_photo != null && component.No2SideNS_photo.Id != null"
                  matTooltip="" class="material-icons upload-container__icon"
                  style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                  (click)="openImage(component.No2SideNS_photo.Id, 'No2SideNS_photo', 6)">
                  add_a_photo
              </i>

          </td> -->

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;height: 10px;"> </mat-label>
              <mat-label>E/W</mat-label>

            </div>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Face_after "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,72)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Face_after type="text"
                     (focus)="Idlr_No_2_side_ES_Face_after.setAttribute('data-value', component.Idlr_No_2_side_ES_Face_after)"
                     (blur)="Idlr_No_2_side_ES_Face_after.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Face_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Face_after, component.Id,component.ToolId,72) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Face_after" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Middle_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,73)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Middle_after type="text"
                     (focus)="Idlr_No_2_side_ES_Middle_after.setAttribute('data-value', component.Idlr_No_2_side_ES_Middle_after)"
                     (blur)="Idlr_No_2_side_ES_Middle_after.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Middle_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Middle_after, component.Id,component.ToolId,73) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Middle_after" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Centre_after"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,74)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Centre_after type="text"
                     (focus)="Idlr_No_2_side_ES_Centre_after.setAttribute('data-value', component.Idlr_No_2_side_ES_Centre_after)"
                     (blur)="Idlr_No_2_side_ES_Centre_after.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Centre_after ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Centre_after, component.Id,component.ToolId,74) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Centre_after" />
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <!-- <td class="table__eval-cell">
              <upload-photo-wsre *ngIf="component.No2SideES_photo == null "
                  (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="13"
                  [relatedId]="component.Id"></upload-photo-wsre>
              <i *ngIf="component.No2SideES_photo != null && component.No2SideES_photo.Id != null"
                  matTooltip="" class="material-icons upload-container__icon"
                  style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                  (click)="openImage(component.No2SideES_photo.Id, 'No2SideES_photo', 7)">
                  add_a_photo
              </i>

          </td> -->

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>Parts ok for reuse Y/N?</td>

          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <mat-label>No.1 side </mat-label>
          </td>

          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Retainer</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_1_side_retainer ==1, 'Fail' : component.Idlr_No_1_side_retainer ==2}">
                {{
component.Idlr_No_1_side_retainer ==1 ? 'YES' :
                                            component.Idlr_No_1_side_retainer ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_1_side_retainerCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_1_side_retainerCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,44)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,44)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,44)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Collar</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_1_side_collar ==1, 'Fail' : component.Idlr_No_1_side_collar ==2}">
                {{
component.Idlr_No_1_side_collar ==1 ? 'YES' :
                                            component.Idlr_No_1_side_collar ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_1_side_CollarCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_1_side_CollarCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,45)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,45)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,45)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Thrust</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_1_side_thrust ==1, 'Fail' : component.Idlr_No_1_side_thrust ==2}">
                {{
component.Idlr_No_1_side_thrust ==1 ? 'YES' :
                                            component.Idlr_No_1_side_thrust ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_1_side_thrustCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_1_side_thrustCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,46)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,46)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,46)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.PartsOkForReuseNo1side_photo == null "
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="14"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.PartsOkForReuseNo1side_photo != null && component.PartsOkForReuseNo1side_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.PartsOkForReuseNo1side_photo.Id, 'PartsOkForReuseNo1side_photo', 8)">
              add_a_photo
            </i>

          </td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <mat-label>No.2 side </mat-label>
          </td>

          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Retainer</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_2_side_retainer  ==1, 'Fail' : component.Idlr_No_2_side_retainer  ==2}">
                {{
component.Idlr_No_2_side_retainer ==1 ? 'YES' :
                                            component.Idlr_No_2_side_retainer ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_2_side_retainerCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_2_side_retainerCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,47)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,47)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,47)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Collar</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_2_side_collar ==1, 'Fail' : component.Idlr_No_2_side_collar ==2}">
                {{
component.Idlr_No_2_side_collar ==1 ? 'YES' :
                                            component.Idlr_No_2_side_collar ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_2_side_collarCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_2_side_collarCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,48)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,48)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,48)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Thrust</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_2_side_thrust ==1, 'Fail' : component.Idlr_No_2_side_thrust ==2}">
                {{
component.Idlr_No_2_side_thrust ==1 ? 'YES' :
                                            component.Idlr_No_2_side_thrust ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_2_side_thrustCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_2_side_thrustCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,49)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,49)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,49)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.PartsOkForReuseNo2side_photo == null "
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="15"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.PartsOkForReuseNo2side_photo != null && component.PartsOkForReuseNo2side_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.PartsOkForReuseNo2side_photo.Id, 'PartsOkForReuseNo2side_photo', 9)">
              add_a_photo
            </i>

          </td>

        </tr>





        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td> </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Bolts</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_2_side_bolts ==1, 'Fail' : component.Idlr_No_2_side_bolts ==2}">
                {{
component.Idlr_No_2_side_bolts ==1 ? 'YES' :
                                            component.Idlr_No_2_side_bolts ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_2_side_boltsCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_2_side_boltsCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,50)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,50)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,50)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;justify-content: space-between;">
              <mat-label style="margin-right: 10px;width: 70px;">Washers</mat-label>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.Idlr_No_2_side_washers ==1, 'Fail' : component.Idlr_No_2_side_washers ==2}">
                {{
component.Idlr_No_2_side_washers ==1 ? 'YES' :
                                            component.Idlr_No_2_side_washers ==2 ?'NO':'N/A'
                }}
                <div class="change-eval"
                     [matMenuTriggerFor]="Idlr_No_2_side_washersCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #Idlr_No_2_side_washersCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,51)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,51)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,51)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre *ngIf="component.BoltsWashers_photo == null "
                               (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="16"
                               [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngIf="component.BoltsWashers_photo != null && component.BoltsWashers_photo.Id != null"
               matTooltip="" class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(component.BoltsWashers_photo.Id, 'BoltsWashers_photo', 10)">
              add_a_photo
            </i>

          </td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>Bearing Internal Measurement</td>

          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;">No.1 Side </mat-label>
              <mat-label>N/S</mat-label>

            </div>


          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>

              <input class="child-input" #Idlr_No_1_side_NS_Face_BIM type="text"
                     (focus)="Idlr_No_1_side_NS_Face_BIM.setAttribute('data-value', component.Idlr_No_1_side_NS_Face_BIM)"
                     (blur)="Idlr_No_1_side_NS_Face_BIM.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Face_BIM ? saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Face_BIM, component.Id,component.ToolId,75) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Face_BIM" />

              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,32)">
              </edit-data> -->
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>

              <input class="child-input" #Idlr_No_1_side_NS_Middle_BIM type="text"
                     (focus)="Idlr_No_1_side_NS_Middle_BIM.setAttribute('data-value', component.Idlr_No_1_side_NS_Middle_BIM)"
                     (blur)="Idlr_No_1_side_NS_Middle_BIM.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Middle_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Middle_BIM, component.Id,component.ToolId,76) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Middle_BIM" />

              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,33)">
              </edit-data> -->
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_NS_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,34)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_NS_Centre_BIM type="text"
                     (focus)="Idlr_No_1_side_NS_Centre_BIM.setAttribute('data-value', component.Idlr_No_1_side_NS_Centre_BIM)"
                     (blur)="Idlr_No_1_side_NS_Centre_BIM.getAttribute('data-value') !== component.Idlr_No_1_side_NS_Centre_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_NS_Centre_BIM, component.Id,component.ToolId,77) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_NS_Centre_BIM" />

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <!-- <upload-photo-wsre *ngIf="component.No1SideNS_photo == null "
                (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="10"
                [relatedId]="component.Id"></upload-photo-wsre>
            <i *ngIf="component.No1SideNS_photo != null && component.No1SideNS_photo.Id != null"
                matTooltip="" class="material-icons upload-container__icon"
                style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                (click)="openImage(component.No1SideNS_photo.Id, 'No1SideNS_photo', 4)">
                add_a_photo
            </i> -->

          </td>

        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="height: 10px;width: 70px;"> </mat-label>
              <mat-label>E/W</mat-label>

            </div>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,35)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_ES_Face_BIM type="text"
                     (focus)="Idlr_No_1_side_ES_Face_BIM.setAttribute('data-value', component.Idlr_No_1_side_ES_Face_BIM)"
                     (blur)="Idlr_No_1_side_ES_Face_BIM.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Face_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Face_BIM, component.Id,component.ToolId,78) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Face_BIM" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,36)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_1_side_ES_Middle_BIM type="text"
                     (focus)="Idlr_No_1_side_ES_Middle_BIM.setAttribute('data-value', component.Idlr_No_1_side_ES_Middle_BIM)"
                     (blur)="Idlr_No_1_side_ES_Middle_BIM.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Middle_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Middle_BIM, component.Id,component.ToolId,79) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Middle_BIM" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_1_side_ES_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,37)">
              </edit-data> -->


              <input class="child-input" #Idlr_No_1_side_ES_Centre_BIM type="text"
                     (focus)="Idlr_No_1_side_ES_Centre_BIM.setAttribute('data-value', component.Idlr_No_1_side_ES_Centre_BIM)"
                     (blur)="Idlr_No_1_side_ES_Centre_BIM.getAttribute('data-value') !== component.Idlr_No_1_side_ES_Centre_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_1_side_ES_Centre_BIM, component.Id,component.ToolId,80) : ''"
                     [(ngModel)]="component.Idlr_No_1_side_ES_Centre_BIM" />
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <!-- <upload-photo-wsre *ngIf="component.No1SideES_photo == null "
                (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="11"
                [relatedId]="component.Id"></upload-photo-wsre>
            <i *ngIf="component.No1SideES_photo != null && component.No1SideES_photo.Id != null"
                matTooltip="" class="material-icons upload-container__icon"
                style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                (click)="openImage(component.No1SideES_photo.Id, 'No1SideES_photo', 5)">
                add_a_photo
            </i> -->

          </td>

        </tr>




        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;">No.2 Side </mat-label>
              <mat-label>N/S</mat-label>

            </div>


          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,38)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_NS_Face_BIM type="text"
                     (focus)="Idlr_No_2_side_NS_Face_BIM.setAttribute('data-value', component.Idlr_No_2_side_NS_Face_BIM)"
                     (blur)="Idlr_No_2_side_NS_Face_BIM.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Face_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Face_BIM, component.Id,component.ToolId,81) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Face_BIM" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,39)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_NS_Middle_BIM type="text"
                     (focus)="Idlr_No_2_side_NS_Middle_BIM.setAttribute('data-value', component.Idlr_No_2_side_NS_Middle_BIM)"
                     (blur)="Idlr_No_2_side_NS_Middle_BIM.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Middle_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Middle_BIM, component.Id,component.ToolId,82) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Middle_BIM" />
            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_NS_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,40)">
              </edit-data> -->


              <input class="child-input" #Idlr_No_2_side_NS_Centre_BIM type="text"
                     (focus)="Idlr_No_2_side_NS_Centre_BIM.setAttribute('data-value', component.Idlr_No_2_side_NS_Centre_BIM)"
                     (blur)="Idlr_No_2_side_NS_Centre_BIM.getAttribute('data-value') !== component.Idlr_No_2_side_NS_Centre_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_NS_Centre_BIM, component.Id,component.ToolId,83) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_NS_Centre_BIM" />

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <!-- <upload-photo-wsre *ngIf="component.No2SideNS_photo == null "
                (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="12"
                [relatedId]="component.Id"></upload-photo-wsre>
            <i *ngIf="component.No2SideNS_photo != null && component.No2SideNS_photo.Id != null"
                matTooltip="" class="material-icons upload-container__icon"
                style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                (click)="openImage(component.No2SideNS_photo.Id, 'No2SideNS_photo', 6)">
                add_a_photo
            </i> -->

          </td>

        </tr>

        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 233">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="width: 70px;height: 10px;"> </mat-label>
              <mat-label>E/W</mat-label>

            </div>

          </td>

          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Face</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Face "
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,41)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Face_BIM type="text"
                     (focus)="Idlr_No_2_side_ES_Face_BIM.setAttribute('data-value', component.Idlr_No_2_side_ES_Face_BIM)"
                     (blur)="Idlr_No_2_side_ES_Face_BIM.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Face_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Face_BIM, component.Id,component.ToolId,84) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Face_BIM" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Middle</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Middle"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,42)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Middle_BIM type="text"
                     (focus)="Idlr_No_2_side_ES_Middle_BIM.setAttribute('data-value', component.Idlr_No_2_side_ES_Middle_BIM)"
                     (blur)="Idlr_No_2_side_ES_Middle_BIM.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Middle_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Middle_BIM, component.Id,component.ToolId,85) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Middle_BIM" />

            </div>
          </td>
          <td>
            <div style="display: flex;flex-direction: row;">
              <mat-label style="margin-right: 10px;width: 70px;">Center</mat-label>
              <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                  [value]="component.Idlr_No_2_side_ES_Centre"
                  (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,43)">
              </edit-data> -->

              <input class="child-input" #Idlr_No_2_side_ES_Centre_BIM type="text"
                     (focus)="Idlr_No_2_side_ES_Centre_BIM.setAttribute('data-value', component.Idlr_No_2_side_ES_Centre_BIM)"
                     (blur)="Idlr_No_2_side_ES_Centre_BIM.getAttribute('data-value') !== component.Idlr_No_2_side_ES_Centre_BIM ?
                                        saveChildComponentMeasurement(component.Idlr_No_2_side_ES_Centre_BIM, component.Id,component.ToolId,86) : ''"
                     [(ngModel)]="component.Idlr_No_2_side_ES_Centre_BIM" />

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <!-- <upload-photo-wsre *ngIf="component.No2SideES_photo == null "
                (onPhotoUpload)="componentPhotoUploaded($event)" [uploadEndPoint]="13"
                [relatedId]="component.Id"></upload-photo-wsre>
            <i *ngIf="component.No2SideES_photo != null && component.No2SideES_photo.Id != null"
                matTooltip="" class="material-icons upload-container__icon"
                style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                (click)="openImage(component.No2SideES_photo.Id, 'No2SideES_photo', 7)">
                add_a_photo
            </i> -->

          </td>

        </tr>



        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 230">

          <td></td>
          <td style="width: 200px;">
            <mat-label style="font-weight: bold;font-style: italic;margin-bottom: 5px;">
              Master
              Links
            </mat-label>
            <div style="display: flex;flex-direction: row;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                <span>
                  Master Link<br />
                  Tooth Count
                </span>
              </div>


              <div style="display: flex;flex-direction: row;
                                        align-items: center;justify-content: flex-end;flex:1">
                <mat-select style="border: 2px solid gray;
                                            height: 40px;width: 70px;
                                            border-radius: 5px;
                                            padding: 10px 10px 10px 10px;"
                            (selectionChange)="saveChildComponentMeasurement($event.value, component.Id,component.ToolId,13)"
                            id="select-department" placeholder="Select Number"
                            [(ngModel)]="SelectedMasterLink" ngDefaultControl>
                  <mat-option [value]="dep.id" *ngFor="let dep of masterLinkList">
                    {{dep.name}}
                  </mat-option>
                </mat-select>
              </div>

            </div>
          </td>
          <td></td>
          <td style="width: 200px;">
            <div style="display: flex;flex-direction: row;justify-content: space-between;">
              <div style="flex:1;display: flex;align-items: center;justify-content: center;">
                <span style="margin-right: 10px;font-weight: bold">Broken Bolt</span>
              </div>

              <div style="flex:1;display: flex;align-items: center;justify-content:center;
                                    flex-direction: column;">
                <span style="font-weight: bold">RHPE</span>

                <div class="pass-fail"
                     [ngClass]="{'Pass': component.BrokenBoltRHPE==2, 'Fail' : component.BrokenBoltRHPE==1}">
                  {{
                     component.BrokenBoltRHPE==1 ? 'YES' : component.BrokenBoltRHPE==2
                                                ?'NO':'N/A'
                  }}
                  <div class="change-eval" [matMenuTriggerFor]="BrokenBoltRHPECrackMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                </div>
                <mat-menu #BrokenBoltRHPECrackMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,18)">
                    YES
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,18)">
                    NO
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,18)">
                    N/A
                  </button>
                </mat-menu>
              </div>



              <div style="flex:1;display: flex;align-items: center;justify-content:center;flex-direction: column;
                                    margin-left: 20px;">
                <span style="font-weight: bold">LHPE</span>
                <div class="pass-fail"
                     [ngClass]="{'Pass': component.BrokenBoltLHPE==2, 'Fail' : component.BrokenBoltLHPE==1}">
                  {{
                     component.BrokenBoltLHPE==1 ? 'YES' : component.BrokenBoltLHPE==2
                                                ?'NO':'N/A'
                  }}
                  <div class="change-eval" [matMenuTriggerFor]="BrokenBoltLHPECrackMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                </div>
                <mat-menu #BrokenBoltLHPECrackMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,19)">
                    YES
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,19)">
                    NO
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,19)">
                    N/A
                  </button>
                </mat-menu>
              </div>
            </div>

          </td>
          <td style="width: 200px;">

            <div style="flex:1;display: flex;align-items: center;justify-content: center;">
              <span style="margin-right: 15px;font-weight: bold">Master Link</span>
              <span style="font-weight: bold">RHPE</span>

            </div>

            <div style="flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <div style="flex:1;display: flex;width: 100px;">
                <span style="margin-right: 10px;">Crack Test Result</span>
              </div>

              <div style="flex:1;display: flex;align-items: flex-end;justify-content:flex-end;">
                <div class="pass-fail"
                     [ngClass]="{'Pass': component.MasterLinkRHPE==1, 'Fail' : component.MasterLinkRHPE==2}">
                  {{
                 component.MasterLinkRHPE==1 ? 'P' : component.MasterLinkRHPE==2
                                                ?'F':'N/A'
                  }}
                  <div class="change-eval" [matMenuTriggerFor]="MasterLinkRHPECrackMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                </div>
                <mat-menu #MasterLinkRHPECrackMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,20)">
                    Passed
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,20)">
                    Failed
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,20)">
                    N/A
                  </button>
                </mat-menu>
              </div>

            </div>
          </td>
          <td style="width: 200px;">
            <div style="flex:1;display: flex;align-items: center;justify-content: center;">

              <span style="font-weight: bold">LHPE</span>

            </div>
            <div style="flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <div style="flex:1;display: flex">
                <span style="margin-right: 10px;">Crack Test Result</span>
              </div>

              <div style="flex:1;display: flex;align-items: flex-end;justify-content:flex-end;">
                <div class="pass-fail"
                     [ngClass]="{'Pass': component.MasterLinkLHPE==1, 'Fail' : component.MasterLinkLHPE==2}">
                  {{
                   component.MasterLinkLHPE==1 ? 'P' : component.MasterLinkLHPE==2
                                                ?'F':'N/A'
                  }}
                  <div class="change-eval" [matMenuTriggerFor]="MasterLinkLHPECrackMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                </div>
                <mat-menu #MasterLinkLHPECrackMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,21)">
                    Passed
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,21)">
                    Failed
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,21)">
                    N/A
                  </button>
                </mat-menu>
              </div>

            </div>
          </td>
          <td style="width: 200px;">
            <div style="flex:1;display: flex;align-items: center;justify-content: center;">

              <span style="font-weight: bold">RHBE</span>

            </div>
            <div style="flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <div style="flex:1;display: flex">
                <span style="margin-right: 10px;">Crack Test Result</span>
              </div>

              <div style="flex:1;display: flex;align-items: flex-end;justify-content:flex-end;">
                <div class="pass-fail"
                     [ngClass]="{'Pass': component.MasterLinkRHBE==1, 'Fail' : component.MasterLinkRHBE==2}">
                  {{
                   component.MasterLinkRHBE==1 ? 'Passed' : component.MasterLinkRHBE==2
                                                ?'Failed':'N/A'
                  }}
                  <div class="change-eval" [matMenuTriggerFor]="MasterLinkRHBECrackMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                </div>
                <mat-menu #MasterLinkRHBECrackMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,22)">
                    Passed
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,22)">
                    Failed
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,22)">
                    N/A
                  </button>
                </mat-menu>
              </div>
            </div>

          </td>
          <td style="width: 200px;">
            <div style="flex:1;display: flex;align-items: center;justify-content: center;">

              <span style="font-weight: bold">LHBE</span>

            </div>
            <div style="flex-direction: row;display: flex;align-items: center;justify-content: center;">
              <span style="margin-right: 10px;">Crack Test Result </span>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.MasterLinkLHBE==1, 'Fail' : component.MasterLinkLHBE==2}">
                {{
                   component.MasterLinkLHBE==1 ? 'P' : component.MasterLinkLHBE==2
                                            ?'F':'N/A'
                }}
                <div class="change-eval" [matMenuTriggerFor]="MasterLinkLHBECrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #MasterLinkLHBECrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,23)">
                  Passed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,23)">
                  Failed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,23)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td class="table__eval-cell">
            <upload-photo-wsre (onPhotoUpload)="componentPhotoUploaded($event)" [ComponentTypeId] = "2" 
                               [uploadEndPoint]="0" [relatedId]="component.Id"></upload-photo-wsre>
            <!-- <img *ngFor="let photo of component.Photos" [src]="getImage(photo.ImageData)" (click)="openImage(photo.Id, 'component')" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngFor="let photo of component.MasterLinkPhotos" matTooltip="{{photo.Title}}"
               class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(photo.Id, 'component')">
              add_a_photo
            </i>
          </td>
        </tr>
        <hr style="margin-top: 0px;margin-bottom: 0px;" *ngIf="component.CompartTypeAuto == 230">
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 230">
          <td></td>
          <td style="display: flex;flex:1;flex-direction: column;">
            <mat-label style="font-weight: bold;font-style: italic;margin-bottom: 5px;height: 10px">
              Other
              Links
            </mat-label>
            <div style="display: flex;flex-direction: row;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                <span style="margin-right: 10px;">
                  Other<br />
                  Link <br />
                  Count
                </span>
              </div>

              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                    [value]="component.OtherLinks!=null?component.OtherLinks:''"
                    (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,1)">
                </edit-data> -->

                <input class="child-input" #OtherLinks type="text"
                       (focus)="OtherLinks.setAttribute('data-value', component.OtherLinks)"
                       (blur)="OtherLinks.getAttribute('data-value') !== component.OtherLinks ?
                                        saveChildComponentMeasurement(component.OtherLinks, component.Id,component.ToolId,1) : ''"
                       [(ngModel)]="component.OtherLinks" />
              </div>


            </div>

          </td>
          <td>
            <div>

              <a class="button button--primary"
                 style="flex-direction: row;justify-content: space-between;display: flex"
                 target="_blank"
                 (click)="CreateDipTests(component.OtherLinks , component.hasDipTests)"
                 [ngClass]="{'lightgray' : component.hasDipTests}">
                <i class="material-icons button__icon">add</i>
                <span class="button__text">Dip Tests</span>
              </a>


            </div>
          </td>
          <td>
            <div style="height: 10px;width: 20px;">
              <br />
            </div>



            <div style="display: flex;flex-direction: row;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                Chipped Links Requiring Replacement
              </div>

              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                    [value]="component.NumberRequiringReplacement!=null?component.NumberRequiringReplacement:''"
                    (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,2)">
                </edit-data> -->

                <input class="child-input" #NumberRequiringReplacement type="text"
                       (focus)="NumberRequiringReplacement.setAttribute('data-value', component.NumberRequiringReplacement)"
                       (blur)="NumberRequiringReplacement.getAttribute('data-value') !== component.NumberRequiringReplacement ?
                                        saveChildComponentMeasurement(component.NumberRequiringReplacement, component.Id,component.ToolId,2) : ''"
                       [(ngModel)]="component.NumberRequiringReplacement" />
              </div>
            </div>


          </td>
          <td></td>
          <td>
            <div style="height: 10px;width: 20px;">
              <br />
            </div>
            <div style="display: flex;flex-direction: row;">
              <div style="flex:1;display: flex;flex: 1.5;margin-right: 5px;">
                Scallop Measurement {{userUom}}
              </div>
              <div style="flex:1;display: flex;align-items: center;justify-content: space-between;flex: 1;">
                <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                    [value]="component.ScallopMeasurment!=null?component.ScallopMeasurment:''"
                    (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,3)">
                </edit-data> -->

                <input class="child-input" #ScallopMeasurment type="text"
                       (focus)="ScallopMeasurment.setAttribute('data-value', component.ScallopMeasurment)"
                       (blur)="ScallopMeasurment.getAttribute('data-value') !== component.ScallopMeasurment ?
                                            saveChildComponentMeasurement(component.ScallopMeasurment, component.Id,component.ToolId,3) : ''"
                       [(ngModel)]="component.ScallopMeasurment" />
              </div>
            </div>



          </td>
          <td></td>

          <td>
            <div style="height: 10px;width: 20px;">
              <br />
            </div>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <span style="margin-right: 10px;">Crack Test Result </span>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.OtherLinkCrack==1, 'Fail' : component.OtherLinkCrack==2}">
                {{
component.OtherLinkCrack==1 ? 'P' : component.OtherLinkCrack==2
                                            ?'F':'N/A'
                }}
                <div class="change-eval" [matMenuTriggerFor]="OtherLinkCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #OtherLinkCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,15)">
                  Passed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,15)">
                  Failed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,15)">
                  N/A
                </button>
              </mat-menu>
            </div>




          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 231">
          <td></td>
          <td>
            <!-- Applied style for TT-9334 Point 1 to hide the Running Side  -->
          <div style="display: none">
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5;margin-right: 5px;">
                Running Side {{userUom}}
              </div>
              
              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                    [value]="component.RunningSide!=null?component.RunningSide:''"
                    (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,4)">
                </edit-data> -->

                <input class="child-input" #RunningSide type="text"
                       (focus)="RunningSide.setAttribute('data-value', component.RunningSide)"
                       (blur)="RunningSide.getAttribute('data-value') !== component.RunningSide ?
                                            saveChildComponentMeasurement(component.RunningSide, component.Id,component.ToolId,4) : ''"
                       [(ngModel)]="component.RunningSide" />
              </div>
            </div>
          </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                <span style="margin-right: 10px;">
                  Reverse<br />
                  Side {{userUom}}
                </span>
              </div>
              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                    [value]="component.ReverseSide!=null?component.ReverseSide:''"
                    (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,5)">
                </edit-data> -->

                <input class="child-input" #ReverseSide type="text"
                       (focus)="ReverseSide.setAttribute('data-value', component.ReverseSide)"
                       (blur)="ReverseSide.getAttribute('data-value') !== component.ReverseSide ?
                                            saveChildComponentMeasurement(component.ReverseSide, component.Id,component.ToolId,5) : ''"
                       [(ngModel)]="component.ReverseSide" />
              </div>
            </div>
          </td>
          <td></td>

          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="flex:1;display: flex">
                <span style="margin-right: 10px;">Bush Turned</span>
              </div>
              <!-- Bush -->
              <div style="flex:1;display: flex;align-items: flex-end;justify-content:flex-end;">
                <div class="pass-fail content-center"
                     [ngClass]="{'Pass': component.BushTurned==1, 'Fail' : component.BushTurned==2}"
                      [matTooltip]="component.BushTurned !== 1 ? bushTurnTooltip : ''" matTooltipPosition="above">
                      {{ component.BushTurned == 1 ? 'YES' : component.BushTurned == 2 ? 'NO' : 'N/A' }}
                  <!-- <div class="change-eval" [matMenuTriggerFor]="BushTurnedCrackMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div> -->
                </div>
                <!-- <mat-menu #BushTurnedCrackMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,8)">
                    YES
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,8)">
                    NO
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,8)">
                    N/A
                  </button>
                </mat-menu> -->
              </div>
            </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <span style="margin-right: 10px;">Crack Test Result </span>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.BushCrack==1, 'Fail' : component.BushCrack==2}">
                {{component.BushCrack==1 ? 'P' : component.BushCrack==2 ?'F':'N/A'}}
                <div class="change-eval" [matMenuTriggerFor]="BushCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #BushCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,16)">
                  Passed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,16)">
                  Failed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,16)">
                  N/A
                </button>
              </mat-menu>

            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 232">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                Shoe Height {{userUom}}
              </div>

              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                    [value]="component.ShoeHight!=null?component.ShoeHight:''"
                    (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,6)">
                </edit-data> -->

                <input class="child-input" #ShoeHight type="text"
                       (focus)="ShoeHight.setAttribute('data-value', component.ShoeHight)"
                       (blur)="ShoeHight.getAttribute('data-value') !== component.ShoeHight ?
                                            saveChildComponentMeasurement(component.ShoeHight, component.Id,component.ToolId,6) : ''"
                       [(ngModel)]="component.ShoeHight" />
              </div>
            </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                Shoe Width {{userUom}}
              </div>


              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <!-- <edit-data [canEdit]="userCanEdit" class="child-input"
                    [value]="component.ShoeWidth!=null?component.ShoeWidth:''"
                    (valueChanged)="saveChildComponentMeasurement($event, component.Id,component.ToolId,7)">
                </edit-data> -->

                <input class="child-input" #ShoeWidth type="text"
                       (focus)="ShoeWidth.setAttribute('data-value', component.ShoeWidth)"
                       (blur)="ShoeWidth.getAttribute('data-value') !== component.ShoeWidth ?
                                            saveChildComponentMeasurement(component.ShoeWidth, component.Id,component.ToolId,7) : ''"
                       [(ngModel)]="component.ShoeWidth" />
              </div>
            </div>
          </td>
          <td></td>
          <td>
            <!-- Shoe R -->
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: center;">
                <span style="margin-right: 10px;">Shoe Relugged {{userUom}}</span>
              </div>
              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;">
                <div class="pass-fail content-center"
                     [ngClass]="{'Pass': component.ShoeReluggedcca==1, 'Fail' : component.ShoeReluggedcca==2}"
                     [matTooltip]="component.ShoeReluggedcca !== 1 ? shoeReluggedTooltip : ''" matTooltipPosition="above">
                     {{component.ShoeReluggedcca==1 ? 'YES' : component.ShoeReluggedcca==2 ?'NO':'N/A'}}
                  <!-- <div class="change-eval" [matMenuTriggerFor]="ShoeReluggedccaMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div> -->
                </div>
                <!-- <mat-menu #ShoeReluggedccaMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,9)">
                    YES
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,9)">
                    NO
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,9)">
                    N/A
                  </button>
                </mat-menu> -->
              </div>
            </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <span style="margin-right: 10px;">Crack Test Result </span>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.ShoeCrack==1, 'Fail' : component.ShoeCrack==2}">
                {{component.ShoeCrack==1 ? 'P' : component.ShoeCrack==2 ?'F':'N/A'}}
                <div class="change-eval" [matMenuTriggerFor]="ShoeCrackMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #ShoeCrackMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,17)">
                  Passed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,17)">
                  Failed
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('', component.Id,component.ToolId,17)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
        <tr style="background-color: #E9EDF2" *ngIf="component.CompartTypeAuto == 232">
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                <span style="margin-right: 10px;">Master shoe</span>
              </div>

              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <div class="pass-fail"
                     [ngClass]="{'Pass': component.Mastershoe==1, 'Fail' : component.Mastershoe==2}">
                  {{component.Mastershoe==1 ? 'YES' : component.Mastershoe==2 ?'NO':'N/A'}}
                  <div class="change-eval" [matMenuTriggerFor]="MastershoeMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                </div>
                <mat-menu #MastershoeMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,10)">
                    YES
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,10)">
                    NO
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,10)">
                    N/A
                  </button>
                </mat-menu>
              </div>
            </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <span style="margin-right: 10px;">All Hardware Present</span>

              <div class="pass-fail"
                   [ngClass]="{'Pass': component.AllHardwarepresent==1, 'Fail' : component.AllHardwarepresent==2}">
                {{component.AllHardwarepresent==1 ? 'YES' : component.AllHardwarepresent==2 ?'NO':'N/A'}}
                <div class="change-eval" [matMenuTriggerFor]="AllHardwarepresentMenu">
                  <i class="material-icons change-eval__icon">mode_edit</i>
                  <span class="change-eval__text">Change</span>
                </div>
              </div>
              <mat-menu #AllHardwarepresentMenu="matMenu">
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,11)">
                  YES
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,11)">
                  NO
                </button>
                <button mat-menu-item
                        (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,11)">
                  N/A
                </button>
              </mat-menu>
            </div>
          </td>
          <td></td>
          <td>
            <div style="display: flex;flex-direction: row;align-items: center;">
              <div style="display: flex;flex-direction: row;align-items: center;flex:1.5">
                <span style="margin-right: 10px;">Hardware Condition</span>
              </div>

              <div style="display: flex;flex-direction: row;align-items: center;justify-content: flex-end;flex:1">
                <div class="pass-fail"
                     [ngClass]="{'Pass': component.HardwareCondition==1, 'Fail' : component.HardwareCondition==2}">
                  {{component.HardwareCondition==1 ? 'Good' : component.HardwareCondition==2 ?'Poor':'N/A'}}
                  <div class="change-eval" [matMenuTriggerFor]="HardwareConditionMenu">
                    <i class="material-icons change-eval__icon">mode_edit</i>
                    <span class="change-eval__text">Change</span>
                  </div>
                </div>
                <mat-menu #HardwareConditionMenu="matMenu">
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('1', component.Id,component.ToolId,12)">
                    Good
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('2', component.Id,component.ToolId,12)">
                    Poor
                  </button>
                  <button mat-menu-item
                          (click)="saveChildComponentMeasurement('0', component.Id,component.ToolId,12)">
                    N/A
                  </button>
                </mat-menu>
              </div>
            </div>
          </td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
          <td></td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-tab>
<!-- <mat-tab label="Crack Tests" *ngIf="crackTestLoaded">
    <div class="panel__content flex flex--top" *ngIf="viewCrackTests">
        <div class="eval" [class.Eval-A]="crackTest.TestPassed" [class.Eval-X]="!crackTest.TestPassed"
            [class.saving-crack-test-eval]="savingCrackTestEval">
            {{crackTest.TestPassed ? 'P' : 'F'}}
            <div class="change-eval" [matMenuTriggerFor]="crackTestEvalMenu" *ngIf="userCanEdit">
                <i class="material-icons change-eval__icon">mode_edit</i>
                <span class="change-eval__text">Change</span>
            </div>
        </div>
        <mat-menu #crackTestEvalMenu="matMenu">
            <button mat-menu-item (click)="updateCrackTestEval(true)">Passed</button>
            <button mat-menu-item (click)="updateCrackTestEval(false)">Failed</button>
        </mat-menu>
        <div style="width: 100%; ">
            <div class="text-block">
                <span class="text-block__label">Comment</span>
                <span class="text-block__important">
                    <edit-data [canEdit]="userCanEdit" [value]="crackTest.Comment" [dataType]="'textarea'"
                        (valueChanged)="saveCrackTestComment($event)">
                    </edit-data>
                </span>
            </div>
            <div class="text-block">

                <td class="table__eval-cell">
                    <upload-photo-wsre (onPhotoUpload)="uploadCrackTestPhotos($event)" [uploadEndPoint]="6"
                        [relatedId]="wsreId"></upload-photo-wsre>



                    <i *ngFor="let photo of  crackTest.Photos" matTooltip="{{photo.Title}}"
                        class="material-icons upload-container__icon"
                        style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
                        (click)="openImage(photo.Id, 'cracktest')">
                        add_a_photo
                    </i>
                </td>


            </div>
        </div>
    </div>
</mat-tab> -->
<mat-tab label="Dip Tests" *ngIf="dipTestsLoaded">
  <div class="panel__content no-padding" *ngIf="viewDipTests">
    <table class="table table--full-width table--striped">
      <thead>
        <tr>
          <th>Pin End Master</th>
          <th>Level</th>
          <th>Condition</th>
          <th>Comment</th>
          <th>Recommendation</th>
          <th>Photos Taken</th>
        </tr>
      </thead>
      <tbody>
        <tr *ngFor="let dipTest of dipTests">
          <td>{{dipTest.Number}}</td>
          <td class="table__eval-cell">
            <div class="Eval-" style="color: #FFFFFF;"
                 [style.background-color]="dipTest.Colour">
              <edit-data style="color: black;
                                border-color:1px solid black;" [canEdit]="userCanEdit" [value]="dipTest.Level"
                         [dataType]="'text-hidden'"
                         (valueChanged)="saveDipTestLevel(dipTest.Id, $event)">
              </edit-data>
            </div>
          </td>
          <td>
            <span *ngIf="!userCanEdit">{{dipTest.Condition}}</span>
            <div *ngIf="userCanEdit" [matMenuTriggerFor]="dipTestConditionMenu"
                 class="change-condition">
              <i class="material-icons change-condition__icon">mode_edit</i><span class="change-condition__text">{{dipTest.Condition}}</span>
            </div>
            <mat-menu #dipTestConditionMenu="matMenu">
              <button mat-menu-item (click)="saveDipTestCondition(dipTest.Id, condition.Id)"
                      *ngFor="let condition of possibleDipTestConditions">
                {{condition.Description}}
              </button>
            </mat-menu>
          </td>
          <td>
            <edit-data [canEdit]="userCanEdit" [value]="dipTest.Comment" [dataType]="'text'"
                       (valueChanged)="saveDipTestComment(dipTest.Id, $event)"></edit-data>
          </td>
          <td>
            <edit-data [canEdit]="userCanEdit" [value]="dipTest.Recommendation"
                       [dataType]="'text'"
                       (valueChanged)="saveDipTestRecommendation(dipTest.Id, $event)"></edit-data>
          </td>
          <td class="table__eval-cell">
            <upload-photo-wsre (onPhotoUpload)="dipTestPhotoUploaded($event)"
                               [uploadEndPoint]="1" [relatedId]="dipTest.Id"></upload-photo-wsre>

            <!-- <img *ngFor="let photo of dipTest.Photos" (click)="openImage(photo.Id, 'diptest')" [src]="getImage(photo.ImageData)" class="component-photo" matTooltip="{{photo.Title}}" /> -->
            <i *ngFor="let photo of  dipTest.Photos" matTooltip="{{photo.Title}}"
               class="material-icons upload-container__icon"
               style="border: 1px solid #ed5565;color: #ed5565; padding: 8px; cursor: pointer;"
               (click)="openImage(photo.Id, 'diptest')">
              add_a_photo
            </i>

          </td>
        </tr>
      </tbody>
    </table>
  </div>
</mat-tab>

    <mat-tab label="Audit Trail" >
      <app-audit-trail *ngIf="systemIdLeft" [systemIdLeft]="systemIdLeft" [screenId]="screenId" [moduleId]="4" [refreshData]="auditRefreshCounter"></app-audit-trail>
      <!-- <div class="panel__content no-padding">
        <table class="table table--full-width table--striped">
          <thead>
            <tr>
              <th>{{'Action Date' | translate | async}}</th>
              <th>{{'Action Description & Comment' | translate | async}}</th>
              <th>{{'Old Value' | translate | async}}</th>
              <th>{{'New Value' | translate | async}}</th>
              <th>{{'Modified By' | translate | async}}</th>
            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let audit of auditTrailHistory">
              <td>{{audit.ActionDate | date:'MM/dd/yyyy'}}</td>
              <td>{{audit.ActionDescription}} {{audit.Comment}}</td>
              <td>{{audit.OldValue}}</td>
              <td>{{audit.NewValue}}</td>
              <td>{{audit.EnteredBy | aesDecrypt}}</td>
            </tr>
          </tbody>
        </table>
        <mat-paginator [length]="auditTrailTotalRecords"
                   [pageSize]="loadSize"
                   [pageSizeOptions]="[5, 10, 25, 100]"
                   (page)="pageChanged($event)">
    </mat-paginator>
      </div> -->
    </mat-tab>
        </mat-tab-group>
    </div>
</div>
